"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Analytics: ()=>Analytics,
    default: ()=>analytics
});
const analytics_namespaceObject = require("@pcln/analytics");
var analytics_default = /*#__PURE__*/ __webpack_require__.n(analytics_namespaceObject);
class Analytics {
    chatbotContext;
    init(data) {
        this.chatbotContext = data;
    }
    fireGA4Event(ga4EventParams) {
        try {
            analytics_default().GA4Enabled = true;
            analytics_default().logEvent(ga4EventParams);
        } finally{
            analytics_default().GA4Enabled = false;
        }
    }
    logError(logData) {
        analytics_default().logError({
            ...this.getBaseAttributes(),
            ...logData
        });
    }
    log({ message = '', ...rest }) {
        analytics_default().log({
            message,
            ...this.getBaseAttributes(),
            ...rest
        });
    }
    logWarning({ name = '', message = '' }) {
        analytics_default().logWarning({
            name,
            message,
            ...this.getBaseAttributes()
        });
    }
    getBaseAttributes() {
        const isBrowser = 'undefined' != typeof window;
        const componentVersionFromWindow = isBrowser ? window?.PCLN_BOOTSTRAP_DATA?.moduleInfo?.['@pcln/penny-chat-bot'] : 'unknown';
        return {
            component: 'PennyChatbot',
            componentVersion: this.chatbotContext?.componentVersion || componentVersionFromWindow,
            requestFrom: this.chatbotContext?.fetchRequestOptions?.headers?.['x-request-from'],
            productId: this.chatbotContext?.submitChatMessagesPayload?.productId,
            cguid: this.chatbotContext?.submitChatMessagesPayload?.cguid,
            rguid: this.chatbotContext?.submitChatMessagesPayload?.rguid
        };
    }
}
const analytics = new Analytics();
exports.Analytics = __webpack_exports__.Analytics;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Analytics",
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
